<template>
  <div>
    <div
      class="pt-5 flex justify-end text-4xl bg-clip-text text-transparent bg-gradient-to-r from-dbs-navy to-dbs-green"
    >
      <!-- <strong>{{ collectCustomerInfo.businessname }}</strong> -->
      <strong>{{ store.meterData.customer.businessname }}</strong>
      <!-- {{--  <img src="http://localhost:3333/logo-scotbeef.png" width="200px" alt="Your Logo">  --}} -->
    </div>
    <div class="pb-5 flex justify-end">
      {{ new Date().toLocaleDateString() }}
    </div>
    <div class="divide-y-[3px] divide-dbs-green">
      <div class="text-xl py-4">
        <strong>Direct Energy Solutions - Meter Audit</strong>
      </div>
      <!-- {{-- * Consumption insight blurb --}} -->
      <div class="py-4">
        <div class="pb-4">
          <strong>Welcome to your DES Meter Audit.</strong>
          <p class="text-sm">
            Our interactive energy audit is designed to help you visualise the
            consumption trends related to the Electricity supply point REF
            <strong>{{ store.meterData.customer.mpan }}</strong
            >. Your DBS energy expert will guide you through the report, explain
            what each section shows, and discuss how this helps to identify
            energy savings opportunities. It’s challenging to manage what you
            don’t measure so, as part of Direct Energy Solutions commitment to
            you, we’ll help you understand your energy data and guide you on how
            to both save money and reduce your carbon footprint.
          </p>
        </div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useAuditStore } from "@/store/index";
const store = useAuditStore();
</script>
